import React, { useState, useRef } from 'react';
import './App.css';
import ImageTransformer from './components/ImageTransformer';
import ImageGallery from './components/ImageGallery';
import ImageModal from './components/ImageModal';

function App() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const galleryRef = useRef(null);

  const handleImageClick = (image) => {
    setSelectedImage({
      imageUrl: image.image_url,
      createdAt: image.created_at
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const handleDownload = async () => {
    if (!selectedImage?.imageUrl) return;

    try {
      const response = await fetch(selectedImage.imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = `lemondick-${Date.now()}.png`;
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert('Failed to download image');
    }
  };

  const handleTransformComplete = () => {
    // Refresh gallery when a new image is generated
    if (galleryRef.current && galleryRef.current.refresh) {
      galleryRef.current.refresh();
    }
  };

  return (
    <div className="App">
      {/* Yellow background elements */}
      <div className="yellow-elements-container">
        <div className="yellow-circle yellow-circle-1"></div>
        <div className="yellow-circle yellow-circle-2"></div>
        <div className="yellow-circle yellow-circle-3"></div>
        <div className="yellow-circle yellow-circle-4"></div>
        <div className="yellow-stripe yellow-stripe-1"></div>
        <div className="yellow-stripe yellow-stripe-2"></div>
        <div className="yellow-blob yellow-blob-1"></div>
        <div className="yellow-blob yellow-blob-2"></div>
      </div>

      {/* Floating lemon emojis */}
      <div className="lemon-container">
        <span className="lemon lemon-1">🍋</span>
        <span className="lemon lemon-2">🍋</span>
        <span className="lemon lemon-3">🍋</span>
        <span className="lemon lemon-4">🍋</span>
        <span className="lemon lemon-5">🍋</span>
        <span className="lemon lemon-6">🍋</span>
        <span className="lemon lemon-7">🍋</span>
        <span className="lemon lemon-8">🍋</span>
        <span className="lemon lemon-9">🍋</span>
        <span className="lemon lemon-10">🍋</span>
        <span className="lemon lemon-11">🍋</span>
        <span className="lemon lemon-12">🍋</span>
        <span className="lemon lemon-13">🍋</span>
        <span className="lemon lemon-14">🍋</span>
        <span className="lemon lemon-15">🍋</span>
      </div>

      <header className="app-header">
        {/* Header floating animations */}
        <div className="header-floaters">
          <span className="header-float header-float-1">🍋</span>
          <span className="header-float header-float-2">🍋</span>
          <span className="header-float header-float-3">🍋</span>
          <span className="header-float header-float-4">🍋</span>
          <span className="header-float header-float-5">🍋</span>
          <span className="header-float header-float-6">🍋</span>
          <span className="header-float header-float-7">🍋</span>
          <span className="header-float header-float-8">🍋</span>
        </div>

        <h1 className="app-title">LemonDick</h1>
        <p className="app-subtitle">Investigative Journalism & Analysis</p>
      </header>

      <main className="app-main">
        <ImageTransformer onTransformComplete={handleTransformComplete} />
        <ImageGallery ref={galleryRef} onImageClick={handleImageClick} />
      </main>

      {showModal && selectedImage && (
        <ImageModal
          image={selectedImage}
          onClose={handleCloseModal}
          onDownload={handleDownload}
        />
      )}

      <footer className="app-footer">
        <p>© 2025 LemonDick. All rights reserved. | Satire & Commentary</p>
      </footer>
    </div>
  );
}

export default App;
